import { MASTER_DATA_CONFIG } from '../headerHelper/MasterDataHeaderHelper';

export interface MasterDataLabelText {
    codeLabel: string;
    nameLabel: string;
    pageTitle: string;
    pageTitlePlural: string;
    createButtonText: string;
    importButtonText: string;
    updatePageTitle: string;
    createPageTitle: string;
    importPageTitle: string;
    deactivateButtonText: string;
    activateButtonText: string;
    confirmDeactivateTitle: string;
    confirmActivateTitle: string;
    confirmDeactivateMessage: string;
    confirmActivateMessage: string;
}

export const MasterDataLabelTextHelper = {
    /**
     * Common field labels used across all master data types
     */
    commonLabels: {
        code: 'Code',
        name: 'Name',
        active: 'Active',
        dateCreateAt: 'Create Date',
        dateModifyAt: 'Modify Date',
        action: 'Action'
    },

    /**
     * Get label text for a specific master data type
     */
    getLabelTextForType: (type: string): MasterDataLabelText => {
        const config = MASTER_DATA_CONFIG[type];
        if (!config) {
            throw new Error(`Unknown master data type: ${type}`);
        }

        return {
            codeLabel: MasterDataLabelTextHelper.commonLabels.code,
            nameLabel: MasterDataLabelTextHelper.commonLabels.name,
            pageTitle: config.displayName,
            pageTitlePlural: config.displayNamePlural,
            createButtonText: `Create New ${config.displayName}`,
            importButtonText: `Import ${config.displayNamePlural}`,
            updatePageTitle: `Update ${config.displayName}`,
            createPageTitle: `Create ${config.displayName}`,
            importPageTitle: `Import ${config.displayNamePlural}`,
            deactivateButtonText: `Deactivate ${config.displayName}`,
            activateButtonText: `Activate ${config.displayName}`,
            confirmDeactivateTitle: `Confirm Deactivate`,
            confirmActivateTitle: `Confirm Activate`,
            confirmDeactivateMessage: `Are you sure you want to deactivate this ${config.displayName.toLowerCase()}?`,
            confirmActivateMessage: `Are you sure you want to activate this ${config.displayName.toLowerCase()}?`
        };
    },

    /**
     * Get validation messages
     */
    getValidationMessages: () => {
        return {
            codeRequired: 'Code is required',
            nameRequired: 'Name is required',
            codeFormat: 'Code must contain only letters, numbers, and underscores',
            duplicateCode: 'A record with this code already exists'
        };
    },

    /**
     * Get success messages
     */
    getSuccessMessages: (type: string) => {
        const config = MASTER_DATA_CONFIG[type];
        if (!config) {
            throw new Error(`Unknown master data type: ${type}`);
        }

        return {
            created: `${config.displayName} created successfully`,
            updated: `${config.displayName} updated successfully`,
            imported: `${config.displayNamePlural} imported successfully`,
            activated: `${config.displayName} activated successfully`,
            deactivated: `${config.displayName} deactivated successfully`
        };
    },

    /**
     * Get error messages
     */
    getErrorMessages: (type: string) => {
        const config = MASTER_DATA_CONFIG[type];
        if (!config) {
            throw new Error(`Unknown master data type: ${type}`);
        }

        return {
            createFailed: `Failed to create ${config.displayName}`,
            updateFailed: `Failed to update ${config.displayName}`,
            loadFailed: `Failed to load ${config.displayNamePlural}`,
            importFailed: `Failed to import ${config.displayNamePlural}`
        };
    }
};
